module.exports = __webpack_public_path__ + "static/media/pcc_sign_in_button_hover_state.e0d0d5a5.svg";